import { call, put, takeLatest } from 'redux-saga/effects';
import { graphql } from '../../../globals/api/requests';

import {
  editListError,
  editListSuccess,
  EDIT_LIST_REQUEST,
  EDIT_LIST_SUCCESS,
} from '../actions/lists';

import updateUser from './update-user';

export function* editList({ id, name, visibility }) {
  try {
    const response = yield call(
      graphql,
      `mutation listEdit($id: Int!, $name: String!, $visibility: ListVisibility!) {
        listEdit(id: $id, name: $name, visibility: $visibility) {
          success
        }
      }`,
      {
        id,
        name,
        visibility,
      }
    );

    if (response.errors) {
      yield put(editListError(response.errors[0]));
      return false;
    }

    if (response.data.listEdit.success) {
      yield put(editListSuccess({ id, name }));
    }
  } catch (error) {
    yield put(editListError(error));
    return false;
  }

  return true;
}

function* mySaga() {
  yield takeLatest(EDIT_LIST_REQUEST, editList);
  yield takeLatest(EDIT_LIST_SUCCESS, updateUser);
}

export default mySaga;
